import { Box } from '@mui/material';
import FormDialog from 'components/Dialogs/FormDialog';
import { ProformaCapTableForm } from 'components/Forms';
import NewRoundModeler from './NewRoundModeler';
import { ProformaCaptableDialogProps } from './ProformaCaptableDialog.props';

const ProformaCaptableDialog = ({
  open,
  title,
  editMode,
  onClose,
  onSave,
  isValid,
  tableTerms,
  initialValues,
  onFormChange,
  captableInfo,
  fundList,
  onNewRoundModelerChange,
  customButtonLabel,
}: ProformaCaptableDialogProps) => (
  <FormDialog
    open={open}
    title={title}
    subtitle="Current Cap Table and Breakpoint Analysis will be copied to the new version"
    editMode={editMode}
    onClose={onClose}
    onSave={onSave}
    isValid={isValid}
    customButtonLabel={customButtonLabel}
    bigDialog>
    <Box>
      <ProformaCapTableForm tableTerms={tableTerms} initialValues={initialValues.values} onFormChange={onFormChange} />
      {captableInfo && onNewRoundModelerChange && (
        <NewRoundModeler
          captableInfo={captableInfo}
          fundList={fundList ?? []}
          onChange={onNewRoundModelerChange}
        />
      )}
    </Box>
  </FormDialog>
);

export default ProformaCaptableDialog;
